import Link from 'next/link';
import classNames from 'classnames';
import Container from '@amf/shared/components/layout/Container';
import { ReactNode } from 'react';

export interface RouterMenuItem {
  title: string;
  url: string;
  selected?: boolean;
}

interface RouterMenuProps {
  items: RouterMenuItem[];
  children?: ReactNode;
  className?: string;
}

function RouterMenu({ items, children, className }: RouterMenuProps) {
  return (
    <div className={classNames('Menu', className)}>
      <Container className='Menu__container'>
        <div className='Menu__content'>
          {items.map(({ url, title, selected }) => (
            <Link key={encodeURI(url)} href={url}>
              <a
                className={classNames('Menu__item', {
                  'Menu__item--active': selected,
                })}
              >
                {title}
              </a>
            </Link>
          ))}
        </div>
        {children && <div className='Menu__children'>{children}</div>}
      </Container>
    </div>
  );
}

export default RouterMenu;
